import { render } from "./WorkRecordEdit.vue?vue&type=template&id=5807ef64&scoped=true"
import script from "./WorkRecordEdit.vue?vue&type=script&lang=js"
export * from "./WorkRecordEdit.vue?vue&type=script&lang=js"

import "./WorkRecordEdit.vue?vue&type=style&index=0&id=5807ef64&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5807ef64"]])

export default __exports__